module.exports = __webpack_public_path__ + "img/calendar.383c1d51.svg";